document.addEventListener('DOMContentLoaded', () => {
    let burger_btn = document.querySelector('.navbar-toggler');

    burger_btn.addEventListener('click', () => {
        burger_btn.classList.toggle('opened');

        let toggleElements = document.querySelectorAll('.js-request');

        toggleElements.forEach(element => {
            if (burger_btn.classList.contains('opened')) {
                element.style.display = 'none';
            } else {
                element.style.display = '';
            }
        });

        if (burger_btn.classList.contains('opened')) {
            document.body.style.overflow = 'hidden';
            document.body.style.width = '100%';
        } else {
            document.body.style.overflow = '';
            document.body.style.width = '';
        }
    });
});
